<template>
  <button
    class="base-button"
    :class="customClass"
    @click.stop.prevent="$emit('click')"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'BaseButton',
  props: {
    inverse: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    accent: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    gray: {
      type: Boolean,
      default: false,
    },
    square: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customClass() {
      const customClass = {
        'base-button--inverse': this.inverse,
        'base-button--block': this.block,
        'base-button--small': this.small,
        'base-button--text': this.text,
        'base-button--secondary': this.secondary,
        'base-button--borderless': this.borderless,
        'base-button--nowrap': this.nowrap,
        'base-button--expanded': this.expanded,
        'base-button--accent': this.accent,
        'base-button--gray': this.gray,
        'base-button--square': this.square,
      };

      return customClass;
    },
  },
};
</script>
<style lang="scss" scoped>
.base-button {
  background-color: white;
  border: solid 1px #333333;
  padding: 5px 30px;
  margin: 0 10px;
  transition: all 0.2s;
  border-radius: 5px;
  font-family: $font-family-sans-serif-light;
  font-size: 0.8125rem;
  display: inline-flex;
  align-items: center;
  color: $black;

  &:focus{
    outline: none;
  }

  &--square{
    background-color: transparent;
    border-radius: 0;
    font-size: 0.6875rem;
    padding: 0.625rem;
    line-height: 1;
    font-family: $font-family-sans-serif-medium;
    margin: 0;
    display: inline-flex;
    justify-content:center;
    align-items: center;
    max-height: 1.75rem;
    white-space: nowrap;
  }

  &--gray {
    border: solid 1px #aaaaaa;
  }

  &--inverse {
    background-color: $black;
    color: white;

    &[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &:hover{
      background: #282828 !important;
    }
  }

  &--block {
    display: block;
    width: 100%;
    margin: 0;
  }

  &--block + &--block {
    margin-top: 0.5rem;
  }

  &--small {
    padding: 5px 10px;
    font-size: 0.75rem;
  }

  &--text {
    border: none !important;
    background: none !important;
  }

  &--secondary {
    border: none !important;
    background: #f2f1ee !important;
  }
  &--accent {
    color: white;
    border: none !important;
    background: $clementine !important;
    &[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &:hover{
      background: darken($clementine, 5%) !important;
    }
  }
  &--borderless {
    border: none !important;
  }

  &--nowrap {
    white-space: nowrap;
  }

  &--expanded {
    min-width: 280px;
    text-align: center;
    padding-top: 13px;
    padding-bottom: 13px;
    justify-content: center;
    font-size: 1rem;
  }

  &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>
